/**
 *  ConfirmQuitScene
 *
 *  Created by Legman on 30/03/2016.
 *
 */

import Common   from "../Common";

/**
 * @class
 */
export default class ConfirmQuitScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._panel = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._yesButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._noButton = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        this._panel = new PIXI.Sprite(assets.getTexture("ui_info_sign"));
        this._panel.x = Common.STAGE_WIDTH * 0.5;
        this._panel.y = Common.STAGE_HEIGHT;
        this._panel.anchor = new PIXI.Point(0.5, 1);
        this._panel.visible = false;
        this.addChild(this._panel);

        if (language === "ar") {
            this._panel.label = new PIXI.Text(translate("confirm_title"), {
                fontSize: "32px", fontFamily: "Noto Kufi Arabic", fill: 0x450C41, align: "center", padding: 6});
            this._panel.label.x = 8;
            this._panel.label.y = -375;
            this._panel.label.rotation = -0.024;
            this._panel.label.pivot.x = this._panel.label.width * 0.5;
            this._panel.label.pivot.y = this._panel.label.height * 0.5;
            this._panel.addChild(this._panel.label);
        } else {
            this._panel.label = new PIXI.BitmapText(translate("confirm_title"), font(34, "center"));
            this._panel.label.x = 8;
            this._panel.label.y = -375;
            this._panel.label.rotation = -0.024;
            this._panel.label.pivot.x = this._panel.label.textWidth * 0.5;
            this._panel.label.pivot.y = this._panel.label.textHeight * 0.5;
            this._panel.label.tint = 0x450C41;
            this._panel.addChild(this._panel.label);
        }

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_tick");

        this._yesButton = new p3.Button(states);
        this._yesButton.x = Common.STAGE_WIDTH * 0.5 + 10 + 130;
        this._yesButton.y = Common.STAGE_HEIGHT * 0.5 + 220;
        this._yesButton.visible = false;
        this._yesButton.interactive = false;
        this._yesButton.overSoundName = "sfx_btn_rollover_00";
        this._yesButton.clickSoundName = "sfx_btn_press_00";
        this._yesButton.signals.click.add(this.onYesButtonClick, this);
        this.addChild(this._yesButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_cross");

        this._noButton = new p3.Button(states);
        this._noButton.x = Common.STAGE_WIDTH * 0.5 + 10 - 130;
        this._noButton.y = Common.STAGE_HEIGHT * 0.5 + 220;
        this._noButton.visible = false;
        this._noButton.interactive = false;
        this._noButton.overSoundName = "sfx_btn_rollover_00";
        this._noButton.clickSoundName = "sfx_btn_press_00";
        this._noButton.signals.click.add(this.onNoButtonClick, this);
        this.addChild(this._noButton);
    }

    appear() {
        super.appear();
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        const to = this._panel.y;
        this._panel.y = this._panel.y + 40;
        TweenMax.to(this._panel, 0.34, {
            y: to,
            ease: Power1.easeInOut,
            onStart: function() {
                this._panel.visible = true;
            },
            onStartScope: this
        });

        this._panel.scale.y = 0;
        TweenMax.to(this._panel.scale, 0.34, {
            y: 1,
            ease: Back.easeInOut,
            easeParams: [2]
        });

        this._noButton.scale = new PIXI.Point();
        TweenMax.to(this._noButton.scale, 0.4, {
            delay: 0.2,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._noButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._noButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._yesButton.scale = new PIXI.Point();
        TweenMax.to(this._yesButton.scale, 0.4, {
            delay: 0.2 + 0.06,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._yesButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._yesButton.interactive = true;
            },
            onCompleteScope: this
        });
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
        const tl = new TimelineMax({onComplete: callback, onCompleteScope: scope});

        tl.insert(TweenMax.to(this._panel, 0.34, {
            y: this._panel.y + 40,
            ease: Power1.easeInOut
        }));
        tl.insert(TweenMax.to(this._panel.scale, 0.34, {
            y: 0,
            ease: Back.easeInOut,
            easeParams: [1],
            onComplete: function() {
                this._panel.visible = false;
            },
            onCompleteScope: this
        }));

        this._yesButton.interactive = false;
        tl.insert(TweenMax.to(this._yesButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._yesButton.visible = false;
            },
            onCompleteScope: this
        }));

        this._noButton.interactive = false;
        tl.insert(TweenMax.to(this._noButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._noButton.visible = false;
            },
            onCompleteScope: this
        }));
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;
    }

    update() {
    }

    /**
     * @param {p3.Button} button
     */
    onYesButtonClick(button) {
        this.signals.next.dispatch(this);
    }

    /**
     * @param {p3.Button} button
     */
    onNoButtonClick(button) {
        this.animateOut(function() {
            this.signals.previous.dispatch(this);
        }, this);
    }
}
